import React, { useState, useEffect } from "react";
import "./style.scss";
import AreasMap from "./components/AreasMap";
import AreasInfo from "./components/AreasInfo";
import HeroSection from "../Home/components/HeroSection/HeroSection";
import bird from "../../assets/images/placeholder.jpg";
import Areas from "../Home/components/Areas/Areas";
import AreasList from "../Home/components/LisbonMap/components/AreasList/AreasList";
import {
  useGetAllAreasQuery,
  useGetAreaQuery,
} from "../../setup/rtk-query/APIs/areaApi";
import { useParams } from "react-router-dom/dist";
import { Alert, Container } from "react-bootstrap";
import { SyncLoader } from "react-spinners";
import { useNavigate } from "react-router-dom/dist";
import { useLocation } from "react-router";

const CityAreas = () => {
  const navigate = useNavigate();
  const area = useParams()?.area?.split("-").join(" ");

  const { data, isError, error, isSuccess, isLoading } = useGetAreaQuery(area);

  const [show, setShow] = useState(true);

  useEffect(() => {
    if (
      error?.data?.error?.includes("mongo id pattern") ||
      error?.status === 404 ||
      data?.data?.length === 0
    )
      navigate("/404");
  }, [error, data]);

  return (
    <div className="city-page">
      {isLoading ? (
        <SyncLoader
          className="text-center pb-5 mt-5 pt-5 m-auto"
          size={12}
          color="#009f3b"
        />
      ) : (
        <div className="">
          <div className="city-image">
            <img src={data?.data[0]?.coverImage || bird} />
            <div className="city-info">
              <div className="container">
                <div className="city-name">
                  {data?.data[0]?.name},{data?.data[0]?.distrito} - Portugal
                </div>
                <div className="stats-cube">
                  <div className="cube">
                    <div className="percent">
                      {data?.data[0]?.dayPct}
                      <span>%</span>
                    </div>
                    <div className="date">Today</div>
                  </div>
                  <div className="cube">
                    <div className="percent">
                      {data?.data[0]?.monthPct}
                      <span>%</span>
                    </div>
                    <div className="date">This Month</div>
                  </div>
                  <div className="cube">
                    <div className="percent">
                      0<span>%</span>
                    </div>
                    <div className="date">Last Day</div>
                  </div>
                  <div className="cube">
                    <div className="percent">
                      0<span>%</span>
                    </div>
                    <div className="date">Last Month</div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <Container className="main-section-container">
            {isError ? (
              <Alert
                variant="danger"
                onClose={() => setShow(false)}
                dismissible
              >
                {error?.data?.error}
              </Alert>
            ) : (
              ""
            )}
            <div className="main-section">
              <div className="areas-map-container">
                <AreasMap data={data?.data[0]} />
              </div>
              <div className="result-container">
                <AreasInfo data={data?.data[0]} />
              </div>
            </div>
            <section className="areas-page areas-in-city">
              <div className="text-title">Another Areas</div>
              <AreasList parent={"area page"}/>
            </section>
          </Container>
        </div>
      )}
    </div>
  );
};

export default CityAreas;
